var _path, _ellipse, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgShoppingResults16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.637389 2.55389C0.184057 2.37947 -0.0864481 1.85644 0.0331989 1.38568C0.152846 0.914917 0.617338 0.674687 1.07067 0.84911L2.42029 1.36839C2.60371 1.43896 2.7572 1.5666 2.86703 1.72476C3.16785 1.73426 3.42565 1.9446 3.48939 2.26504L5.31711 11.453H14.381C14.8742 11.453 15.2741 11.8528 15.2741 12.3461C15.2741 12.8393 14.8742 13.2392 14.381 13.2392H5.27924C5.1777 13.2392 5.08013 13.2222 4.98918 13.191C4.96679 13.2002 4.94385 13.2083 4.92041 13.2154C4.53102 13.3327 4.15104 13.1044 4.0717 12.7055L2.16505 3.1208C2.10604 3.11177 2.04643 3.09603 1.987 3.07317L0.637389 2.55389Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.56366,
    cy: 15.0255,
    rx: 1.45173,
    ry: 1.78619,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3705,
    cy: 15.0255,
    rx: 1.45173,
    ry: 1.78619,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23486 3.75824C3.08187 3.12871 3.55872 2.52209 4.20657 2.52209H14.7764C15.4087 2.52209 15.8822 3.10158 15.7563 3.72121L14.5483 9.66687H4.67078L3.23486 3.75824Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingResults16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;